import styled, { css } from "styled-components"

export const TextButton = styled.div<{ $isDisabled: boolean }>`
  ${({ theme, $isDisabled }) => css`
      font-size: ${theme.typography.fontSizeButtonSmall};
      cursor: pointer;
      color: ${theme.colors.grey};
      font-family: ${theme.typography.fontFamily};
      text-decoration: underline;
  
      ${$isDisabled && css`
        cursor: not-allowed;
        text-decoration: none;
        color: ${theme.colors.blackLight};
    `}
  `};
 
`
